import { v4 as uuidv4 } from 'uuid';

// 工单状态常量
export const WORK_ORDER_STATUS = {
  PENDING: 'pending',           // 待执行
  IN_PROGRESS: 'in_progress',   // 服务中
  COMPLETED: 'completed',       // 已完成
  SETTLED: 'settled',           // 已结算
  CANCELLED: 'cancelled',       // 已取消
  FOLLOWUP_NEEDED: 'followup_needed', // 需随访
  FOLLOWED_UP: 'followed_up'    // 已随访
};

// 随访状态常量
export const WORK_ORDER_FOLLOWUP_STATUS = {
  NO_FOLLOWUP: 'no_followup',
  FOLLOWUP_NEEDED: 'followup_needed',
  FOLLOWED_UP: 'followed_up'
};

class WorkOrder {
  /**
   * Constructor
   * @param {Object} data - Work order data
   */
  constructor(data = {}) {
    this.id = data.id || uuidv4();
    this.appointmentId = data.appointmentId || '';
    this.customerId = data.customerId || '';
    this.practitionerId = data.practitionerId || '';
    this.treatmentProjectId = data.treatmentProjectId || '';
    this.treatmentProjectName = data.treatmentProjectName || '';
    this.scheduledTime = data.scheduledTime || '';
    this.room = data.room || '';
    this.status = data.status || WORK_ORDER_STATUS.PENDING;
    this.summary = data.summary || '';
    this.followUpStatus = data.followUpStatus || WORK_ORDER_FOLLOWUP_STATUS.NO_FOLLOWUP;
    this.treatmentRecordIds = Array.isArray(data.treatmentRecordIds) ? data.treatmentRecordIds : (data.treatmentRecordId ? [data.treatmentRecordId] : []);
    this.createdAt = data.createdAt || new Date().toISOString();
    this.updatedAt = data.updatedAt || new Date().toISOString();
    this.callHistory = data.callHistory || []; // [{ time, operatorId, treatmentRecordId, type: 'call'|'recall', note }]
  }

  /**
   * Update work order data
   * @param {Object} data - Data to update
   * @returns {WorkOrder} Updated work order instance
   */
  update(data) {
    Object.keys(data).forEach(key => {
      if (data[key] !== undefined && key !== 'id') {
        if (key === 'treatmentRecordId') {
          // Backward compatibility: add to array
          if (!this.treatmentRecordIds.includes(data[key])) {
            this.treatmentRecordIds.push(data[key]);
          }
        } else if (key === 'treatmentRecordIds' && Array.isArray(data[key])) {
          this.treatmentRecordIds = data[key];
        } else {
          this[key] = data[key];
        }
      }
    });
    this.updatedAt = new Date().toISOString();
    return this;
  }

  /**
   * Add a treatment record ID
   * @param {string} recordId
   */
  addTreatmentRecordId(recordId) {
    if (!this.treatmentRecordIds.includes(recordId)) {
      this.treatmentRecordIds.push(recordId);
      this.updatedAt = new Date().toISOString();
    }
  }

  /**
   * Remove a treatment record ID
   * @param {string} recordId
   */
  removeTreatmentRecordId(recordId) {
    this.treatmentRecordIds = this.treatmentRecordIds.filter(id => id !== recordId);
    this.updatedAt = new Date().toISOString();
  }

  /**
   * 叫号/再次叫号
   * @param {Object} param0
   * @param {string} param0.operatorId
   * @param {string} param0.treatmentRecordId
   * @param {string} [param0.type] - 'call'|'recall'
   * @param {string} [param0.note]
   */
  callNumber({ operatorId, treatmentRecordId, type = 'call', note = '' }) {
    this.callHistory.push({
      time: new Date().toISOString(),
      operatorId,
      treatmentRecordId,
      type,
      note
    });
    this.updatedAt = new Date().toISOString();
  }

  /**
   * Convert to JSON for storage
   * @returns {Object} JSON representation
   */
  toJSON() {
    return {
      id: this.id,
      appointmentId: this.appointmentId,
      customerId: this.customerId,
      practitionerId: this.practitionerId,
      treatmentProjectId: this.treatmentProjectId,
      treatmentProjectName: this.treatmentProjectName,
      scheduledTime: this.scheduledTime,
      room: this.room,
      status: this.status,
      summary: this.summary,
      followUpStatus: this.followUpStatus,
      treatmentRecordIds: this.treatmentRecordIds,
      createdAt: this.createdAt,
      updatedAt: this.updatedAt,
      callHistory: this.callHistory
    };
  }

  /**
   * Create work order from JSON data
   * @param {Object} json - JSON data
   * @returns {WorkOrder} WorkOrder instance
   * @static
   */
  static fromJSON(json) {
    return new WorkOrder(json);
  }
}

export default WorkOrder; 